import { compose, mapProps, withProps } from 'recompose';
import SelectInput from '@/se/components/inputs/SelectInput';
import { ROOM_TYPE_LABELS, PATIENT_ROOM_TYPES } from '../../entities/room/enums';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import { withScope } from '@/contexts/ScopeContext';

export default compose(
  withScope,
  mapProps(({ scope, ...props }) => {
    const hasInpatients = scope?.hospital?.modules?.hasPostop;

    const patientLabels = pick(ROOM_TYPE_LABELS, PATIENT_ROOM_TYPES);
    return {
      options: hasInpatients ? patientLabels : omit(patientLabels, ['POST_OP']),
      label: props.label,
      ...props,
    };
  }),
  withProps({
    placeholder: 'e.g., OR',
    required: true,
  })
)(SelectInput);
